import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, StatusMark } from '../../components/ui';
import { formatDateUTC } from '../../utils/dates';
import { formatCredits } from '../../utils/credits';

export default function RunRow({ run, credits, onCopy }) {
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  const inFlight = useRef(false);
  const mounted = useRef(true);
  useEffect(() => () => { mounted.current = false; }, []);

  const copy = async () => {
    if (inFlight.current) return;
    inFlight.current = true;
    setBusy(true);
    setFailed(false);
    try {
      await onCopy();
    } catch {
      if (mounted.current) setFailed(true);
    } finally {
      inFlight.current = false;
      if (mounted.current) setBusy(false);
    }
  };

  return (
    <li className="flex items-center gap-3 flex-wrap bg-card border-1.5 border-ink rounded-[14px] px-4 py-3">
      <StatusMark status={run.status} />
      <div className="min-w-0 flex-1">
        <div className="font-bold truncate">{run.title}</div>
        <div className="text-sm text-pencil">
          {`${run.steps} steps · ${formatDateUTC(run.at, { withTime: true })}`}
        </div>
      </div>
      {typeof credits === 'number' && <span className="text-sm">{formatCredits(credits)}</span>}
      {failed && <span role="alert" className="text-sm text-status-failed">Couldn't copy.</span>}
      <Button asChild variant="secondary" size="sm">
        <Link to={`/runs/open?workflow=${encodeURIComponent(run.id)}&view=visualization`}>Open</Link>
      </Button>
      <Button variant="ghost" size="sm" onClick={copy} disabled={busy}>
        {busy ? 'Copying…' : 'Copy to canvas'}
      </Button>
    </li>
  );
}
